module.exports = __webpack_public_path__ + "static/media/era_logo.1d12b415.gif";